import React from "react";

export const ProfileHead = ({ activeItem }) => {
  return (
    <div
      className="flex justify-center items-center py-6  border-b border-gray-300"
      style={{ color: "white",backgroundColor:"#b5a262" }}
    >
      {activeItem === "my orders" || activeItem === "my enrollments" ? (
        <span className="hidden" />
      ) : (
        <h2
          className="text-4xl font-semibold capitalize text-center tracking-wide"
          style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)" ,color: "white",}}
        >
          {activeItem}
        </h2>
      )}
    </div>
  );
};
